
export const storeLoginData = (data) => {
    try {
      localStorage.setItem("loginData", JSON.stringify(data));
    } catch (error) {
      console.error("Error storing login data:", error);
    }
  };
  
  // Retrieve login data from localStorage
  export const getLoginData = () => {
    try {
      const loginData = localStorage.getItem("loginData");
      return loginData ? JSON.parse(loginData) : null;
    } catch (error) {
      console.error("Error getting login data:", error);
      return null;
    }
  };
  
  // Remove login data from localStorage
  export const removeLoginData = () => {
    try {
      localStorage.removeItem("loginData");
    } catch (error) {
      console.error("Error removing login data:", error);
    }
  };
  
  // Check if login data exists in localStorage
  export const isLoggedIn = () => {
    try {
      return localStorage.getItem("loginData") !== null;
    } catch (error) {
      console.error("Error checking login status:", error);
      return false;
    }
  };
  